import { createSelector } from 'reselect';
import {
    getAssetsIsLoadingSelector,
    getCollectionsIsLoadingSelector,
    getIsLiteTradeAccountPortfolioInited,
    getLiteTradeCollectionsFilteredMap,
    getLiteTradePortfolioVisibleOrdersSelector,
    getLiteTradePortfolioVisiblePositionsSelector,
} from '../../../modules/LiteTrade/liteTradeSelectors';
import {
    getAppUser,
    getIsFirstDealDoneSelector,
    getIsUserBuyerSelector,
    getIsUserSelectedAccountTypeLive,
    getUserHasLiveAccount,
    getUserSelectedAccountType
} from '../../../app/appSelectors';
import { ACCOUNT_TYPES } from '../../../app/appConstants';
import { COLLECTION_KEYS } from "../MobileMarket/mobileMarketConstants";

export const getIsShowPortfolioToRealAccountBannerSelector = createSelector(
    [getUserSelectedAccountType, getUserHasLiveAccount], (selectedAccountType, hasLiveAccount) =>
        selectedAccountType === ACCOUNT_TYPES.DEMO && hasLiveAccount
);

export const getIsShowPortfolioBannerCarouselSelector = createSelector(
    [getUserSelectedAccountType, getIsUserBuyerSelector, getIsFirstDealDoneSelector], (selectedAccountType, isBuyer, isFirstDealOpened) => {
        return !(isBuyer && !isFirstDealOpened) || selectedAccountType === ACCOUNT_TYPES.DEMO;
    }
);

export const getIsShowPortfolioLastViewedAssetsSelector = createSelector(
    getLiteTradeCollectionsFilteredMap, state => state[COLLECTION_KEYS.LAST_VIEWED]?.assets?.length > 0
);

export const getIsShowPortfolioSelectAssetBannerSelector = createSelector(
    [
        getIsLiteTradeAccountPortfolioInited,
        getUserSelectedAccountType,
        getIsUserBuyerSelector,
        getIsFirstDealDoneSelector,
        getIsShowPortfolioLastViewedAssetsSelector,
        getCollectionsIsLoadingSelector,
        getAssetsIsLoadingSelector,
    ], (isPortfolioInited, selectedAccountType, isBuyer, isFirstDealOpened, isShowLastViewedAssets, collectionsIsLoading, assetsIsLoading) =>
        isPortfolioInited &&
        selectedAccountType === ACCOUNT_TYPES.LIVE &&
        isBuyer && !isFirstDealOpened && !isShowLastViewedAssets && !collectionsIsLoading && !assetsIsLoading
);

export const getIsShowPortfolioTutorialListWidgetSelector = createSelector(
    [
        getAppUser,
        getIsUserSelectedAccountTypeLive,
        getIsLiteTradeAccountPortfolioInited,
        getIsUserBuyerSelector,
        getIsFirstDealDoneSelector,
    ], (user, isLiveAccount, isPortfolioInited, isBuyer, isFirstDealOpened) =>
        !!user?.show_tutorials_portfolio && (
            isLiveAccount
                ? isPortfolioInited && !isBuyer && !isFirstDealOpened
                : !isBuyer && !isFirstDealOpened
        )
);

export const getIsShowPortfolioAchievementProgressSelector = createSelector([getIsLiteTradeAccountPortfolioInited, getLiteTradePortfolioVisiblePositionsSelector, getLiteTradePortfolioVisibleOrdersSelector], (isPortfolioInited, visiblePositions, visibleOrders) => {
    return isPortfolioInited && !visiblePositions.length && !visibleOrders.length;
})
